import { render, staticRenderFns } from "./vivaMarksEntryForm.vue?vue&type=template&id=4f3c5e0c&"
import script from "./vivaMarksEntryForm.vue?vue&type=script&lang=js&"
export * from "./vivaMarksEntryForm.vue?vue&type=script&lang=js&"
import style0 from "./vivaMarksEntryForm.vue?vue&type=style&index=0&id=4f3c5e0c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports